module.exports = __webpack_public_path__ + "img/621.9c60b541.jpg";